import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Dialog, ICON_SIZE } from '../design-system';
import { getTierDisplayName } from '@papper/shared/reedle/tiers';

const UsageDowngradeModal = ({ onClose, confirmModal, currentTier, subscription, handleScheduleDowngrade, actionLoading }) => {
  const { t } = useTranslation('modals');
  return (
    <Dialog
      isOpen
      onClose={onClose}
      ariaLabel={t('usage.plan.confirmDowngradeTitle')}
      showClose={false}
      className="usage-coming-soon-modal"
    >
      <h3>{t('usage.plan.confirmDowngradeTitle')}</h3>
      <p>{t('usage.plan.confirmDowngradeMessage', {
        currentTier: getTierDisplayName(currentTier),
        newTier: getTierDisplayName(confirmModal.targetTier),
        date: subscription?.current_period_end
          ? new Date(subscription.current_period_end).toLocaleDateString()
          : ''
      })}</p>
      <div className="usage-confirm-buttons">
        <button
          className="usage-confirm-btn cancel"
          onClick={onClose}
          disabled={actionLoading !== null}
        >
          {t('common.cancel', { defaultValue: 'Cancel' })}
        </button>
        <button
          className="usage-confirm-btn confirm"
          onClick={() => handleScheduleDowngrade(confirmModal.targetTier)}
          disabled={actionLoading !== null}
        >
          {actionLoading?.startsWith('downgrade:') ? (
            <><Loader2 size={ICON_SIZE.xs} className="spin" /> {t('usage.plan.processing')}</>
          ) : (
            t('usage.plan.confirmDowngrade')
          )}
        </button>
      </div>
    </Dialog>
  );
};

export default UsageDowngradeModal;
